import { render, staticRenderFns } from "./DeleteReportModal.vue?vue&type=template&id=0642ea52&"
import script from "./DeleteReportModal.vue?vue&type=script&lang=js&"
export * from "./DeleteReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports